<template>

  <data-form
    :entity="controller"
    :fields="fields"
    :cancel="false"
    ignoreEntityChanges
    @submit="submit"
  />

</template>

<script>
import { post } from '../../providers/http'

export default {
  name: 'controller-tx-power',
  props: {
    controller: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      fields: {
        'txPower': {
          rules: [{ required: true, type: 'number', max: 15, min: 0 }],
          type: 'number'
        }
      }
    }
  },
  methods: {
    submit ({ txPower }) {
      post(`api/v1/controllers/txpower/${this.controller.id}`, { txPower })
    }
  }
}
</script>



// WEBPACK FOOTER //
// ControllerTxPower.vue?6e4b79e7